<template>
  <span>
    <span v-if="content && content.charLength <= limit">{{ content }}</span>
    <span v-else>
      <span>
        <hardword-reactive :value="truncate(content, limit, '')">
        </hardword-reactive>
      </span>
      <tooltip-switch
        :content="replace"
        :tip="content"
        :link="link"
        :position="position"
        :showTipEvent="showTipEvent"
      >
      </tooltip-switch>
    </span>
  </span>
</template>

<script>
import TooltipSwitch from "./TooltipSwitch";
import HardwordReactive from "@/desktop/views/mv/components/HardwordReactive";
export default {
  components: { HardwordReactive, TooltipSwitch },
  props: {
    content: {
      type: String
    },
    limit: {
      type: Number,
      default: 12,
    },
    replace: {
      type: String
    },
    link: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: "top",
    },
    showTipEvent: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
